/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";
import {useSnackbar} from "notistack";

const useLoadScoredScene = (videoKey, scoredSceneKey) => {

    // Video information (will only be exported for reading)
    const [selectedVideo, setSelectedVideo] = useState()
    const [selectedScoredScene, setSelectedScoredScene] = useState()

    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the fresh video data
    const fetchVideoData = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/videos/' + videoKey + '?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const videoJson = await data.json();
                setSelectedVideo(videoJson)
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.scoredScene.messages.load.video.error',
                        defaultMessage: 'Something went wrong while loading the video: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
    }

    // Retrieving the fresh scoredScene data
    const fetchScoredSceneData = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/scoredScenes/' + scoredSceneKey + '?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const scoredSceneJson = await data.json();
                setSelectedScoredScene(scoredSceneJson)
                return scoredSceneJson
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.scoredScene.messages.load.scene.error',
                        defaultMessage: 'Something went wrong while loading the video scene: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
    }

    useEffect(() => {
        // If only the scoredScene key is provided
        if (scoredSceneKey && !videoKey) {
            fetchScoredSceneData()
                .then(() => {
                    setLoading(false)
                })
        } else {
            // Wait until the data is fetched before removing the loading indication
            fetchVideoData()
                .then(() => {
                    if (scoredSceneKey) {
                        return fetchScoredSceneData()
                    }
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }, [])


    return {
        loading,
        selectedVideo,
        selectedScoredScene
    }
}
export default useLoadScoredScene;